import * as React from 'react';
import cn from 'classnames';
import { SpinnerOverlay } from '@weddingspot/ws-core-components';
import ShoppingCartCTAButton from '../shopping-cart-cta-button';

const styles = require('./VenueInterestedCTA.scss');

interface State {
    ctaSpinning: boolean;
}

interface Props {
    venueId: number;
    isPriced: boolean;
    onClickContact?: () => void;
    showAdditionalPriceVenueButton: boolean;
    estimateTotal?: number;
    // Shopping Card Props
    venueName: string;
    venueLocation: string;
    venueImageUrl?: string;
    shoppingListAllowed?: boolean;
    handleAddVenueToShoppingCart?: () => void;
    handleRemoveVenueFromShoppingCart?: () => void;
    sourcePage?: string;
}

export default class InterestedCTA extends React.Component<Props> {
    static defaultProps: Partial<Props> = {
        onClickContact: () => {},
    };

    readonly state: State = {
        ctaSpinning: false,
    };

    constructor(props: Props) {
        super(props);
        this.setCtaSpinning = this.setCtaSpinning.bind(this);
    }

    private setCtaSpinning() {
        this.setState({ ctaSpinning: true });
    }

    renderButtons() {
        const props = this.props;
        let defaultCtaContactBtn = (
            <button className={cn('nx-button', styles.ctaButton)} onClick={this.props.onClickContact}>
                {this.props.isPriced ? 'CONTACT VENUE' : 'REQUEST A QUOTE'}
            </button>
        );

        if (props.shoppingListAllowed) {
            return (
                <ShoppingCartCTAButton
                    venueId={props.venueId}
                    venueName={props.venueName}
                    venueLocation={props.venueLocation}
                    venueImageUrl={props.venueImageUrl}
                    sourcePage={props.sourcePage}
                />
            );
        } else if (!props.showAdditionalPriceVenueButton) {
            return defaultCtaContactBtn;
        } else if (!!props.estimateTotal || !props.isPriced) {
            return defaultCtaContactBtn;
        } else {
            return (
                <div>
                    <SpinnerOverlay
                        isSpinning={this.state.ctaSpinning}
                        spinnerProps={{
                            spinnerDiameter: 30,
                        }}
                    >
                        <a
                            className={cn('nx-button', styles.ctaButton)}
                            href={`/pricing/${props.venueId}/estimate/`}
                            onClick={this.setCtaSpinning}
                            rel='nofollow'
                        >
                            PRICE THIS VENUE
                        </a>
                    </SpinnerOverlay>
                    <div className={styles.ctaLink}>
                        <a onClick={this.props.onClickContact}>CONTACT VENUE</a>
                    </div>
                </div>
            );
        }
    }

    public render() {
        return (
            <div className={styles.className}>
                <h3 className={styles.headline}>Interested in this venue?</h3>
                <p className={styles.textCenter}>
                    Don't miss out! Message this venue now to check their availability and receive more information.
                </p>
                <p className={cn(styles.muted, styles.textCenter)}>No commitment required.</p>
                <div className={styles.textCenter}>{this.renderButtons()}</div>
            </div>
        );
    }
}
